module.exports = __webpack_public_path__ + "static/media/lcg-shape-pink.5175de30.svg";